module.exports = __webpack_public_path__ + "img/CM_ROASTED.2fc3d9a2.png";